function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M130 42l20-20-20-20v40z",
  stroke: "#1722A2"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M149.75 22H0",
  stroke: "#1722A2"
});

function SvgArrow(props) {
  return React.createElement("svg", _extends({
    width: 151,
    height: 44,
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUxIiBoZWlnaHQ9IjQ0IiB2aWV3Qm94PSIwIDAgMTUxIDQ0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEzMCA0MkwxNTAgMjJMMTMwIDJWNDJaIiBzdHJva2U9IiMxNzIyQTIiLz4KPHBhdGggZD0iTTE0OS43NSAyMkgwIiBzdHJva2U9IiMxNzIyQTIiLz4KPC9zdmc+Cg==";
export { SvgArrow as ReactComponent };